import { createActions } from 'reduxsauce';

export const { Types, Creators } = createActions({
  addFreeSampleRequest: ['payload'],
  removeFreeSampleRequest: ['payload'],
  select: ['payload'],
  unselect: ['payload'],
}, { prefix: '[FREE SAMPLES] ' });
